import { Layout } from './shared/components';
import { OnboardingForm, OnboardingFormSteps } from './pages'
import {ROUTES} from "./shared/constants/navigation";

const routes = [
  {
    component: Layout,
    path: ROUTES.ROOT,
    routes: [
      {
        path: ROUTES.ROOT,
        component: OnboardingForm,
        routes: [
          {
            path: ROUTES.SIGN_UP_CONTACT_INFORMATION,
            component: OnboardingFormSteps.ContactInformation
          },
          {
            path: ROUTES.SIGN_UP_INSTANCES,
            component: OnboardingFormSteps.InstancesConfiguration
          },
          {
            path: ROUTES.SIGN_UP_ADD_ONS,
            component: OnboardingFormSteps.AddOns
          },
          {
            path: ROUTES.SIGN_UP_BILLING,
            component: OnboardingFormSteps.BillingInformation
          },
          {
            path: ROUTES.SIGN_UP_ORDER_DETAILS,
            component: OnboardingFormSteps.OrderDetails
          },
          {
            path: ROUTES.SIGN_UP_CONFIRMATION,
            component: OnboardingFormSteps.InstancesConfirmation
          },
          {
            path: ROUTES.SIGN_UP_CONTACT,
            component: OnboardingFormSteps.ContactUs
          },
          {
            path: ROUTES.ROOT,
            component: OnboardingFormSteps.ContactInformation
          }
        ]
      },

    ]
  }
];

export default routes;
